







import Vue from "vue";
import { mapState } from "vuex";
import { Action } from "@/constants/ajax";
import { ServerResponse } from "@/models/ServerResponse";
import { ResponseStatus } from "@/constants/ajax";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { UtilityHelper } from "@/helpers/UtilityHelper";

Vue.use(VueReCaptcha, {
  siteKey: UtilityHelper.isOandaPath()
    ? process.env.VUE_APP_OANDA_RECAPTCHA_PUBLIC_KEY
    : process.env.VUE_APP_TMS_RECAPTCHA_PUBLIC_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
  },
});

export default Vue.extend({
  name: "RecaptchaSubmitButton",
  props: {
    action: Number,
    data: Object,
    buttonValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    async submitForm(action: Action): Promise<void> {
      const t: any = this;

      this.isSubmitting = true;

      await this.$recaptchaLoaded();

      const formPayload = t.data;

      formPayload.recaptchaToken = await this.$recaptcha("RecaptchaButton");

      this.$store
        .dispatch("ajax", {
          action: t.action,
          data: formPayload,
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  watch: {
    response(newValue) {
      if (newValue.status === ResponseStatus.SUCCESS) {
        this.$emit("successSubmit");
      }
    },
  },
  computed: {
    ...mapState(["response"]),
  },
});
